export class Portal {
  showMoveOut: boolean;
  showAutopayOnPortalHome: boolean;
  notifyOfChanges: boolean;
  showReviewButton: boolean;
  reviewButtonText: string;
  reviewButtonUrl: string;
  autopayBlurb: string;
  minimumMoveOutDays?: number;
  maximumMoveOutDays?: number;

  constructor() {
    this.showMoveOut = false;
    this.notifyOfChanges = true;
    this.showAutopayOnPortalHome = true;
    this.showReviewButton = false;
    this.reviewButtonText = 'Leave a Review';
    this.reviewButtonUrl = '';
    this.autopayBlurb = '** We take security very seriously. We do not store any Credit Card information on our servers. All data is stored on secure servers. **';
  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/models/portal.ts